import {config} from '../config';

const getIsRestrictedMarket = () => config.data.restrictedMarket.isRestrictedMarket;

export default {
    getIsRestrictedMarket,
    getRestrictedAssetsImagePath: () =>
        getIsRestrictedMarket() ? config.data.restrictedMarket.restrictedAssetsImagePath : undefined,
};
